import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appRestrictSpecialChars]',
  standalone: false
})
export class RestrictSpecialCharsDirective {

  private specialChars = /[^a-zA-Z0-9\s]/g; // Regular expression to match special characters

  constructor(private _el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: InputEvent): void {
    const input = this._el.nativeElement as HTMLInputElement;
    const cleanedValue = input.value.replace(this.specialChars, ''); // Remove special characters
    if (input.value !== cleanedValue) {
      input.value = cleanedValue; // Set the cleaned value
      event.stopImmediatePropagation(); // Prevent further propagation
    }
  }

}
